// Module
var code = "<record-form-view fields=\"machinesWarehouseComponentController.formFields\" model=\"machinesWarehouseComponentController.model\" title=\"Warehouse Machine\" on-submit=\"machinesWarehouseComponentController.submit(formViewController)\" on-cancel=\"machinesWarehouseComponentController.cancel(formViewController)\"></record-form-view> ";
// Exports
export default code;